/**
 * Pick the right "thanks-after-raise" template variant based on the
 * driver's personality traits.
 *
 * 11/02/2026 (Lot N suite 2) — UX enhancement : when the player accepts
 * a raise request, the driver sends a short personalised thank-you
 * note (info-only, ttl 14 days) confirming the next 6-month cooldown.
 *
 * Priority order (first match wins) :
 *   • ambitieux       → drv-thanks-after-raise-ambitieux
 *   • fier            → drv-thanks-after-raise-fier
 *   • loyal / pragmatique / autres → drv-thanks-after-raise-loyal
 *
 * @param {Object} driver - Driver record (must expose `personalityTraits`).
 * @returns {string} Template id ready for pushMessageFromTemplate.
 */
export function pickThanksAfterRaiseTemplate(driver) {
  const traits = (driver && driver.personalityTraits) || [];
  if (traits.includes('ambitieux')) return 'drv-thanks-after-raise-ambitieux';
  if (traits.includes('fier')) return 'drv-thanks-after-raise-fier';
  return 'drv-thanks-after-raise-loyal';
}
